import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as productSearchActions from './productSearchActions';
import PseudoCitySubStation from './PseudoCitySubStation';
import {GlobalHeader, BackButton} from '../common/GlobalHeader';
import classnames from 'classnames';

class DestinationFilterContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true
    };

    this.goToOriginFilter = this.goToOriginFilter.bind(this);
    this.selectSubStation = this.selectSubStation.bind(this);
    this.renderStations = this.renderStations.bind(this);
  }

  componentWillMount() {
    let {
      origin_selections: origins,
      destination_station_result: d,
    } = this.props;

    this.props.actions.validateStations(origins, d.sub_stations);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.validations_loading !== nextProps.validations_loading) {
      this.setState({
        loading: nextProps.validations_loading
      });
    }
  }

  goToOriginFilter() {
    this.props.actions.openOriginFilter(true);
  }

  selectSubStation(sub_station, closed) {
    if(closed) return () => {};
    return (e) => {
      this.props.actions.filterDestinationsAndContinue(sub_station);
    }
  }

  renderStations() {
    let {
      destination_station_result: {sub_stations},
      validations
    } = this.props;

    let {loading} = this.state;

    if(!Array.isArray(sub_stations) || !validations) { return; }

    if(loading) {
      return <span className="section-loader"><span className="fa fa-spinner fa-spin"/></span>
    }

    return (
      sub_stations.map((sub_station) => {
        return (
          <PseudoCitySubStation
            key={`${sub_station.result_type}_${sub_station.result_id}`}
            station={sub_station}
            validation={validations[sub_station.code]}
            select={this.selectSubStation}
            />
        );
      })
    );
  }

  render() {
    return (
      <div className="page-layout">
        <GlobalHeader
          leftComponent={<BackButton onClick={this.goToOriginFilter} />}
          title='Select Destination' />

        <div className="page-layout-body">

          <p className="filter-title">
            Specify a destination within
            <br />
            <span>
              {this.props.destination_station_result.title}
            </span>
          </p>

          <hr />

          <div className="station-results">
            <div class="results">
              {this.renderStations()}
            </div>
          </div>

        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    origin_selections: state.productSearch.origin_selections,
    destination_station_result: state.productSearch.destination_station_result,
    validations_loading: state.productSearch.selected_stations_validation.loading,
    validations: state.productSearch.selected_stations_validation.destinations
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(productSearchActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DestinationFilterContainer)